import React from 'react';
import TrainingOptionItem from './TrainingOptionItem';
import { TrainingOptionsSectionProps } from './Types';
import CustomHeader from '../CustomHeader';
import CustomSubTitle from '../CustomSubTitle';
import {
  getHeaderLevel,
  getTextColorClass,
  getTextAlignmentClass,
} from '../../../services/generalUtils';

const TrainingOptions = ({
  title,
  subtitle,
  backgroundStyle,
  titleStyle,
  subTitleStyle,
  options,
  optionAlignment,
  optionMobileAlignment,
  optionIconColor,
  optionTextColor,
}: TrainingOptionsSectionProps) => {
  return (
    <div className="flex justify-center mt-[30px]">
      <section
        className="py-8 px-6 lg:py-12 lg:px-8 w-full max-w-[385px] min-h-[556px] lg:max-w-[1332px] lg:min-h-[315px] rounded-lg shadow-md"
        style={{
          backgroundColor: backgroundStyle?.color || '#4298B5',
          backgroundImage: backgroundStyle?.image
            ? `url(${backgroundStyle.image})`
            : undefined,
          backgroundSize: backgroundStyle?.size || 'cover',
          backgroundPosition: backgroundStyle?.position || 'center',
          backgroundRepeat: backgroundStyle?.repeat || 'no-repeat',
          ...(backgroundStyle?.gradientOverlay && {
            backgroundBlendMode: 'overlay',
            background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), ${
              backgroundStyle?.image ? `url(${backgroundStyle.image})` : ''
            }`,
          }),
        }}
      >
        <div className="w-full">
          <CustomHeader
            text={title.toLowerCase()}
            headerStyle={{
              color: getTextColorClass(titleStyle?.color),
              level: getHeaderLevel(titleStyle?.level),
              alignment: getTextAlignmentClass(titleStyle?.alignment),
              fontFamily: 'Source Sans 3',
              fontWeight: 600,
              fontSize: '23px',
              lineHeight: '28px',
              letterSpacing: '0%',
              textTransform: 'uppercase',
              className:
                'text-[23px] leading-[28px] md:text-[34px] md:leading-[32px]',
            }}
          />
          <CustomSubTitle subtitle={subtitle} subTitleStyle={subTitleStyle} />
          <div className="mt-12 lg:mt-10 grid grid-cols-2 gap-x-3 gap-y-8 md:grid-cols-3 md:gap-4 lg:grid-cols-5 lg:gap-5">
            {options.map((option, index) => (
              <TrainingOptionItem
                key={`${index}-${option.text}`}
                iconUrl={option.iconUrl}
                text={option.text}
                optionAlignment={optionAlignment}
                optionMobileAlignment={optionMobileAlignment}
                optionIconColor={optionIconColor}
                optionTextColor={optionTextColor}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingOptions;
